import { ActionType } from "./action-type";
import * as C from "./question";
import { Maybe } from "./util/maybe";
const QuestionCategories = C.QuestionCategories;
export const layoutIcons = [
    "01_New",
    "02_IntakeComplete",
    "03_Touring",
    "04_ScheduledToMove",
    "05_RecentlyMoved",
    "06_InvoiceSent",
    "07_ClientInfo",
    "08_ContactPerson",
    "09_Notes",
    "16_IdealLocation",
    "17_Budget",
    "18_CommunityTypes",
    "19_Amenities",
    "20_HealthNeeds",
    "21_PotentialCommunities",
    "22_ClientInterest",
    "23_TaskComplete",
    "24_TaskNew",
    "25_ActiveTasks",
    "26_CommunityContacts",
    "27_CommunityRecords",
    "28_ContractDetails",
    "29_ClientSummary",
    "30_Search",
    "31_AdvancedSearch",
    "32_RecentlyPaid",
    "33_OtherDetails",
    "34_ADLs",
    "35_PowerOfAttorney",
    "36_CheckBackLater",
    "37_DefaultCommunityAltColor",
    "38_ReferralSource",
    "39_Business",
    "40_ReferralPerson",
    "41_WorldGlobe",
    "42_ClientAndCommunity",
    "43_SocialInterests",
    "44_SignedAgreement",
    "45_Summary",
    "46_MoreContacts",
    "47_Gear",
    "48_Personal",
    "49_Info",
    "50_Lock",
    "51_Staff",
    "52_StaffAltColor",
    "53_insurance",
    "54_physician",
    "55_photos",
    "56_Couple",
    "57_Community",
];
export const parseLayoutIcon = (icon) => {
    if (!icon) {
        return Maybe.none();
    }
    if (layoutIcons.includes(icon)) {
        return Maybe.fromValue(icon);
    }
    return Maybe.none();
};
export const questionMetadata = {};
questionMetadata[QuestionCategories.type] = {
    clientHeading: "Community Attributes Desired",
    communityHeading: "Community Attributes",
    optionHeading: "Community Attributes",
    icon: "18_CommunityTypes",
    showOption: true,
    allowsCustomSettings: true,
    clientEnabled: true,
    communityEnabled: true,
    category: QuestionCategories.type,
};
questionMetadata[QuestionCategories.amenity] = {
    clientHeading: "Preferred Amenities",
    communityHeading: "Amenities Offered",
    optionHeading: "Amenities",
    icon: "19_Amenities",
    showOption: true,
    allowsCustomSettings: true,
    clientEnabled: true,
    communityEnabled: true,
    category: QuestionCategories.amenity,
};
questionMetadata[QuestionCategories.services] = {
    clientHeading: "Health Needs",
    communityHeading: "Health Services",
    optionHeading: "Health Needs",
    icon: "20_HealthNeeds",
    showOption: true,
    allowsCustomSettings: true,
    clientEnabled: true,
    communityEnabled: true,
    category: QuestionCategories.services,
};
questionMetadata[QuestionCategories.finance] = {
    clientHeading: "Finances",
    communityHeading: "Finances",
    optionHeading: "Finances",
    icon: "17_Budget",
    showOption: true,
    allowsCustomSettings: true,
    clientEnabled: true,
    communityEnabled: true,
    category: QuestionCategories.finance,
};
questionMetadata[QuestionCategories.activity] = {
    clientHeading: "Activities of Daily Living",
    communityHeading: "Activities of Daily Living",
    optionHeading: "Activities of Daily Living",
    icon: "34_ADLs",
    showOption: true,
    allowsCustomSettings: true,
    clientEnabled: true,
    communityEnabled: true,
    category: QuestionCategories.activity,
};
questionMetadata[QuestionCategories.otherDetails] = {
    clientHeading: "Other Details",
    communityHeading: "Other Details",
    optionHeading: "Other Details",
    icon: "33_OtherDetails",
    showOption: true,
    allowsCustomSettings: true,
    clientEnabled: true,
    communityEnabled: true,
    category: QuestionCategories.otherDetails,
};
questionMetadata[QuestionCategories.communityRecords] = {
    clientHeading: "",
    optionHeading: "Community Records",
    communityHeading: "Community Records",
    icon: "27_CommunityRecords",
    showOption: true,
    allowsCustomSettings: true,
    clientEnabled: false,
    communityEnabled: true,
    category: QuestionCategories.communityRecords,
};
questionMetadata[QuestionCategories.socialInterests] = {
    clientHeading: "Social / Personality",
    optionHeading: "Social / Personality",
    communityHeading: "",
    icon: "43_SocialInterests",
    showOption: true,
    allowsCustomSettings: true,
    clientEnabled: true,
    communityEnabled: false,
    category: QuestionCategories.socialInterests,
};
questionMetadata[QuestionCategories.insurance] = {
    clientHeading: "Insurance",
    optionHeading: "Insurance",
    communityHeading: "Insurance",
    icon: "53_insurance",
    showOption: true,
    allowsCustomSettings: false,
    clientEnabled: true,
    communityEnabled: true,
    category: QuestionCategories.insurance,
};
questionMetadata[QuestionCategories.physician] = {
    clientHeading: "Physician",
    optionHeading: "Physician",
    communityHeading: "Physician",
    icon: "54_physician",
    showOption: true,
    allowsCustomSettings: false,
    clientEnabled: true,
    communityEnabled: true,
    category: QuestionCategories.physician,
};
questionMetadata[QuestionCategories.summary] = {
    clientHeading: "Client Summary",
    optionHeading: "Summary",
    communityHeading: "",
    icon: "45_Summary",
    showOption: true,
    allowsCustomSettings: true,
    clientEnabled: true,
    communityEnabled: false,
    category: QuestionCategories.summary,
};
questionMetadata[QuestionCategories.contract] = {
    clientHeading: "",
    optionHeading: "Contract Details",
    communityHeading: "Contract Details",
    icon: "28_ContractDetails",
    showOption: true,
    allowsCustomSettings: true,
    clientEnabled: false,
    communityEnabled: true,
    category: QuestionCategories.contract,
    requiredPermissions: [ActionType.ViewCommunityContract],
};
questionMetadata[QuestionCategories.staff] = {
    clientHeading: "Desired Staffing",
    optionHeading: "Staff",
    communityHeading: "Staff",
    icon: "51_Staff",
    showOption: true,
    allowsCustomSettings: true,
    clientEnabled: true,
    communityEnabled: true,
    category: QuestionCategories.staff,
};
questionMetadata[QuestionCategories.flexible] = {
    clientHeading: "Flexible",
    optionHeading: "Flexible",
    communityHeading: "Flexible",
    icon: "47_Gear",
    showOption: true,
    allowsCustomSettings: true,
    clientEnabled: true,
    communityEnabled: true,
    category: QuestionCategories.flexible,
};
export const isCustomizableSection = (perspective, category) => {
    return Maybe.fromValue(category)
        .map(c => questionMetadata[c])
        .map(m => {
        if (perspective === C.Perspective.Client) {
            return m.clientEnabled;
        }
        else if (perspective === C.Perspective.Community) {
            return m.communityEnabled;
        }
        else {
            console.error("Unknown perspective");
            return false;
        }
    })
        .getOrElse(false);
};
export const allQuestionMetadata = () => {
    const result = [];
    for (const category in QuestionCategories) {
        if (typeof QuestionCategories[category] === "string") {
            result.push(questionMetadata[category]);
        }
    }
    return result;
};
//# sourceMappingURL=question-detail.js.map